<template>
  <div class="revisit-rate">
    <!-- 标题 -->
    <Title type="特殊" title="贴敷复诊率" @setting-click="handleSetting" />
    
    <!-- 图表容器 -->
    <div class="chart-container">
      <div id="revisitRateChart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import resize from "@/components/Charts/mixins/resize";
import Title from "../title.vue";

export default {
  name: 'RightRevisitRate',
  mixins: [resize],
  components: {
    Title
  },
  data() {
    return {
      chart: null,
      // 示例数据 - 保证有五条数据
      chartData: {
        categories: [],
        values: []
      }
    }
  },
  mounted() {
    this.initChart()
    this.loadData()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    initChart() {
      this.$nextTick(() => {
        const chartDom = document.getElementById('revisitRateChart')
        if (!chartDom) return
        
        this.chart = echarts.init(chartDom, 'dark')
        
        const option = {
          backgroundColor: 'transparent',
          // 图例位置调整，与标题在同一行
          legend: {
            show: true,
            data: ['复诊率'],
            top: 10,
            left: '55%', // 在标题右侧
            itemGap: 5,
            itemWidth: 12,
            itemHeight: 12,
            textStyle: {
              color: '#fff',
              fontSize: 12
            },
            icon: 'rect',
            selectedMode: false
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: (params) => {
              const param = params[0]
              return `${param.name}<br/>复诊率: ${param.value}`
            },
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            borderColor: '#74ffbe',
            borderWidth: 1,
            textStyle: {
              color: '#fff',
              fontSize: 12
            }
          },
          toolbox: {
            show: true,
            right: 10,
            top: 10,
            feature: {
              saveAsImage: {
                show: true,
                title: '下载',
                iconStyle: {
                  borderColor: '#fff'
                }
              },
              dataZoom: {
                show: false
              },
              restore: {
                show: false
              },
              dataView: {
                show: false
              }
            },
            iconStyle: {
              borderColor: '#fff'
            },
            emphasis: {
              iconStyle: {
                borderColor: '#74ffbe'
              }
            }
          },
          // 横坐标拖动功能 - 控制 xAxis
          dataZoom: [
            {
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              start: 0,
              end: 100, // 初始显示前60%的数据（约3条）
              height: 20,
              bottom: 10,
              handleStyle: {
                color: '#6DF4BA',
                borderColor: '#6DF4BA'
              },
              dataBackground: {
                areaStyle: {
                  color: 'rgba(109, 244, 186, 0.2)'
                },
                lineStyle: {
                  color: '#6DF4BA',
                  width: 1
                }
              },
              selectedDataBackground: {
                areaStyle: {
                  color: 'rgba(109, 244, 186, 0.4)'
                },
                lineStyle: {
                  color: '#6DF4BA',
                  width: 2
                }
              },
              textStyle: {
                color: '#fff',
                fontSize: 11
              },
              borderColor: '#6DF4BA',
              fillerColor: 'rgba(109, 244, 186, 0.2)',
              handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23.1h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
              handleSize: '100%'
            }
          ],
          color: ['#6DF4BA'], // 设置系列颜色为薄荷绿色
          // grid: {
          //   left: '10%',
          //   right: '10%',
          //   bottom: '20%', // 为滑块留出空间
          //   top: '20%',
          //   containLabel: true
          // },
          // X轴改为类目轴（横坐标）- 垂直柱状图
          xAxis: {
            type: 'category',
            data: this.chartData.categories,
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
                width: 1
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#fff',
              fontSize: 11,
              interval: 0,
              rotate: 0, // 可以设置为45度旋转如果标签太长
              formatter: (value) => {
                return value
              }
            }
          },
          // Y轴改为数值轴（纵坐标）
          yAxis: {
            type: 'value',
            // min: 0,
            // max: 0.35,
            interval: 0.05,
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
                width: 1
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)',
                width: 1,
                type: 'solid'
              }
            },
            axisLabel: {
              color: '#fff',
              fontSize: 11,
              formatter: (value) => {
                return value.toFixed(2)
              }
            }
          },
          series: this.chartData.values
        }
        
        this.chart.setOption(option)
        
        // 响应式调整
        window.addEventListener('resize', () => {
          if (this.chart) {
            this.chart.resize()
          }
        })
      })
    },
    loadData() {
      this.$http.post(process.env.VUE_APP_API_HOST + "/cal_fuzhenlv_drugs_of_dis", {
        "chart_type": "bar",
        "extra_params": {
          "diag": "请选择",
          "shengqu": "",
          "diban": "",
          "date_start": "2025-12-01 00:00:00",
          "date_end": "2025-12-08 23:59:59"
        }
      }).then((res) => {
        if (res.data && res.data.data) {
          // const valueData = res.data.data || []
          let valueData = res.data.data.map(item =>{
            if(item.data){
              item.data = item.data.map(valueNum =>{
                  return Number(valueNum)
              })
            }
            return item
          })
          this.chartData = {
            categories: res.data.dates,
            values: valueData
          }
          // 重新初始化图表
          this.initChart()
        }
      })
    },
    handleSetting() {
      // 处理设置按钮点击事件
      // 可以打开设置对话框或触发其他操作
      console.log('设置按钮被点击')
      // this.$emit('setting-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.revisit-rate {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;
  box-sizing: border-box;

  .chart-container {
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    position: relative;

    #revisitRateChart {
      width: 100%;
      height: 100%;
      min-height: 200px;
    }
  }
}
</style>

